<template>
  <v-avatar :size="size">
    <v-img alt="Avatar" :src="signedUrl || fallbackUrl">
      <template #placeholder>
        <div class="d-flex justify-center align-center h-100 w-100">
          <v-progress-circular indeterminate color="primary" />
        </div>
      </template>
    </v-img>
  </v-avatar>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AvatarAsset',
  props: {
    signedUrl: {
      type: String,
    },
    size: {
      type: [Number, String],
      default: 84,
    },
    seed: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    fallbackUrl(): string {
      return `https://api.dicebear.com/7.x/shapes/svg?seed=${this.seed}`
    },
  },
})
</script>
